import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { ResidentialService } from '../services/residential.service';

@Injectable()
export class CommercialResolver  {

  constructor(private resService: ResidentialService) {}

  resolve() {
    return this.resService.getFormData('commercial')
      .pipe(map(result => result));
  }
}
